export type FrToolCategory =
  | "Tirages au Sort & Sélection"
  | "Roues Interactives"
  | "Groupes & Équipes"
  | "Classe & École"
  | "Jeux & Animation";

export interface FrToolMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  category: FrToolCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const FR_CATEGORIES: FrToolCategory[] = [
  "Tirages au Sort & Sélection",
  "Roues Interactives",
  "Groupes & Équipes",
  "Classe & École",
  "Jeux & Animation",
];

export const FR_TOOLS: FrToolMeta[] = [
  {
    slug: "tirage-au-sort-prenoms",
    enSlug: "random-name-picker",
    name: "Tirage au Sort de Prénoms en Ligne",
    tagline: "Sélectionnez un nom ou un élève de manière équitable avec animation interactive.",
    category: "Tirages au Sort & Sélection",
    icon: "Shuffle",
    featured: true,
    keywords: ["tirage au sort prenom", "tirage au sort nom", "selecteur de nom aleatoire", "tirer un nom au sort"],
  },
  {
    slug: "tirage-au-sort-eleves",
    enSlug: "random-student-picker",
    name: "Sélectionneur d'Élèves Aléatoire pour Classe",
    tagline: "Saisissez la liste de la classe et tirez au sort un élève sans répétition.",
    category: "Tirages au Sort & Sélection",
    icon: "GraduationCap",
    featured: true,
    keywords: ["tirage au sort eleve", "choisir un eleve au sort", "selecteur eleve classe", "tirer eleve au sort"],
  },
  {
    slug: "roue-de-la-fortune-en-ligne",
    enSlug: "spin-the-wheel",
    name: "Roue de la Fortune en Ligne (Faire Tourner la Roue)",
    tagline: "Faites tourner la roue colorée interactive pour prendre une décision rapide.",
    category: "Roues Interactives",
    icon: "Disc3",
    featured: true,
    keywords: ["roue de la fortune en ligne", "faire tourner la roue", "roue de decision", "roue aleatoire en ligne"],
  },
  {
    slug: "roue-des-prenoms",
    enSlug: "wheel-of-names",
    name: "Roue des Prénoms (Tirage au Sort Visuel)",
    tagline: "Ajoutez des prénoms et tournez la roue pour désigner un gagnant.",
    category: "Roues Interactives",
    icon: "Disc3",
    featured: true,
    keywords: ["roue des prenoms", "roue tirage au sort", "roue nom aleatoire", "roue interactive prenoms"],
  },
  {
    slug: "roue-oui-non",
    enSlug: "yes-or-no-wheel",
    name: "Roue Oui ou Non (Décision Instantanée 50/50)",
    tagline: "Tournez le tourne-décision 50/50 pour obtenir une réponse immédiate.",
    category: "Roues Interactives",
    icon: "HelpCircle",
    featured: true,
    keywords: ["roue oui non", "roue decision oui non", "tirage oui non", "generateur oui ou non"],
  },
  {
    slug: "roue-des-cadeaux",
    enSlug: "prize-wheel",
    name: "Roue des Cadeaux & Récompenses en Ligne",
    tagline: "Faites tourner la roue pour offrir des récompenses ou tirages au sort.",
    category: "Roues Interactives",
    icon: "Gift",
    featured: true,
    keywords: ["roue des cadeaux", "roue des recompenses", "roue concours en ligne", "roue tirage au sort cadeau"],
  },
  {
    slug: "roue-des-nombres",
    enSlug: "number-wheel",
    name: "Roue des Nombres Aléatoires 1-100",
    tagline: "Faites tourner une roue numérotée pour vos tirages et jeux de mathématiques.",
    category: "Roues Interactives",
    icon: "Hash",
    keywords: ["roue des nombres", "roue chiffree", "roue nombre aleatoire"],
  },
  {
    slug: "que-manger-roue",
    enSlug: "food-wheel",
    name: "Roue Que Manger Ce Soir ? (Choix de Repas)",
    tagline: "Indécis pour le repas ? Tournez la roue culinaire pour choisir votre plat.",
    category: "Roues Interactives",
    icon: "Utensils",
    keywords: ["que manger ce soir roue", "roue repas", "roue choix de nourriture", "quoi manger ce soir"],
  },
  {
    slug: "generateur-d-equipes-aleatoire",
    enSlug: "team-generator",
    name: "Générateur d'Équipes Aléatoires & Équilibrées",
    tagline: "Divisez un groupe ou une classe en équipes équilibrées en un clic.",
    category: "Groupes & Équipes",
    icon: "Users",
    featured: true,
    keywords: ["generateur d equipes aleatoire", "creer des equipes aleatoires", "faire des equipes au sort"],
  },
  {
    slug: "createur-de-groupes",
    enSlug: "group-maker",
    name: "Créateur de Groupes Aléatoires pour Classe & Travail",
    tagline: "Formez des petits groupes selon le nombre de participants ou la taille souhaitée.",
    category: "Groupes & Équipes",
    icon: "UsersRound",
    keywords: ["createur de groupes", "faire des groupes aleatoires", "generateur de groupe de travail"],
  },
  {
    slug: "generateur-de-binomes",
    enSlug: "partner-generator",
    name: "Générateur de Binômes & Paires Aléatoires",
    tagline: "Créez des duos et binômes de travail instantanément en classe.",
    category: "Groupes & Équipes",
    icon: "Handshake",
    keywords: ["generateur de binomes", "creer des binomes aleatoires", "former des duos au sort"],
  },
  {
    slug: "generateur-de-nombre-aleatoire",
    enSlug: "random-number-generator",
    name: "Générateur de Nombre Aléatoire en Ligne",
    tagline: "Tirez des numéros uniques ou avec répétition dans n'importe quel intervalle.",
    category: "Tirages au Sort & Sélection",
    icon: "Hash",
    keywords: ["generateur de nombre aleatoire", "tirage au sort chiffre", "generer un chiffre au hasard"],
  },
  {
    slug: "lancer-de-des-en-ligne",
    enSlug: "dice-roller",
    name: "Lancer de Dés Virtuel en Ligne (D4 à D100)",
    tagline: "Lancez 1 à 6 dés virtuels avec animation réaliste pour vos jeux de société.",
    category: "Jeux & Animation",
    icon: "Dices",
    keywords: ["lancer de des en ligne", "de virtuel", "lancer un de", "des virtuels 3d"],
  },
  {
    slug: "pile-ou-face-en-ligne",
    enSlug: "coin-flip",
    name: "Pile ou Face en Ligne (Tirage Rapide 50/50)",
    tagline: "Lancer de pièce virtuel rapide pour trancher en une seconde.",
    category: "Jeux & Animation",
    icon: "CircleDollarSign",
    keywords: ["pile ou face en ligne", "lancer de piece virtuel", "tirage pile ou face"],
  },
  {
    slug: "minuteur-classe-en-ligne",
    enSlug: "classroom-timer",
    name: "Minuteur pour Classe & Compte à Rebours Interactif",
    tagline: "Grand chrono plein écran adapté au vidéoprojecteur de la classe.",
    category: "Classe & École",
    icon: "Timer",
    featured: true,
    keywords: ["minuteur classe en ligne", "compte a rebours ecole", "chronometre projetable"],
  },
  {
    slug: "plan-de-classe-aleatoire",
    enSlug: "seating-chart",
    name: "Plan de Classe Aléatoire & Dispositions d'Élèves",
    tagline: "Placez vos élèves au hasard par rangées, îlots ou paires puis imprimez.",
    category: "Classe & École",
    icon: "LayoutGrid",
    keywords: ["plan de classe aleatoire", "placement eleves au hasard", "generateur plan de classe"],
  },
  {
    slug: "responsabilites-classe-tirage",
    enSlug: "classroom-helper-picker",
    name: "Tirage des Responsabilités & Métiers de Classe",
    tagline: "Attribuez les rôles de classe (chef de rang, effaceur de tableau...).",
    category: "Classe & École",
    icon: "Sparkles",
    keywords: ["responsabilites classe tirage", "metiers de classe au sort", "service classe eleve"],
  },
  {
    slug: "generateur-de-lettre-aleatoire",
    enSlug: "random-letter-picker",
    name: "Générateur de Lettre Aléatoire A-Z",
    tagline: "Tirez une lettre de l'alphabet (voyelles, consonnes) pour le baccalauréat.",
    category: "Tirages au Sort & Sélection",
    icon: "Type",
    keywords: ["generateur de lettre aleatoire", "lettre au hasard a-z", "tirage au sort lettre petit bac"],
  },
  {
    slug: "generateur-de-mots-aleatoires",
    enSlug: "random-word-picker",
    name: "Générateur de Mots Aléatoires en Français",
    tagline: "Tirez des mots français classés par difficulté pour l'écriture et le dessin.",
    category: "Tirages au Sort & Sélection",
    icon: "BookA",
    keywords: ["generateur de mots aleatoires", "mot au hasard francais", "liste de mots tirage au sort"],
  },
  {
    slug: "generateur-de-choix-aleatoire",
    enSlug: "random-choice-picker",
    name: "Générateur de Choix Aléatoire & Prise de Décision",
    tagline: "Laissez l'outil sélectionner une option dans votre liste personnalisée.",
    category: "Tirages au Sort & Sélection",
    icon: "ListChecks",
    keywords: ["generateur de choix aleatoire", "outil prise de decision", "faire un choix au hasard"],
  },
  {
    slug: "generateur-oui-non",
    enSlug: "yes-or-no-picker",
    name: "Générateur Oui ou Non — Réponse Instantanée",
    tagline: "Obtenez un Oui, Non ou Peut-être rapide pour débloquer votre choix.",
    category: "Tirages au Sort & Sélection",
    icon: "CircleHelp",
    keywords: ["generateur oui non", "reponse oui non au hasard", "decision oui ou non"],
  },
  {
    slug: "generateur-de-couleur-aleatoire",
    enSlug: "random-color-picker",
    name: "Générateur de Couleur Aléatoire & Code Hex",
    tagline: "Générez une couleur avec son nom et son code HEX / RGB.",
    category: "Tirages au Sort & Sélection",
    icon: "Palette",
    keywords: ["generateur de couleur aleatoire", "couleur au hasard hex", "palette couleur aleatoire"],
  },
  {
    slug: "generateur-de-questions-aleatoires",
    enSlug: "random-question-picker",
    name: "Générateur de Questions Aléatoires & Sujets de Débat",
    tagline: "Tirez une question orale pour stimuler la réflexion et la discussion.",
    category: "Tirages au Sort & Sélection",
    icon: "MessageCircleQuestion",
    keywords: ["generateur de questions aleatoires", "question au hasard pour classe", "sujet de discussion au sort"],
  },
  {
    slug: "roue-de-la-chance",
    enSlug: "lucky-wheel",
    name: "Roue de la Chance & Tirage Chanceux",
    tagline: "Une roue ludique pour attribuer des bonus et moments amusants.",
    category: "Roues Interactives",
    icon: "Gift",
    keywords: ["roue de la chance", "roue chanceuse", "tirage chance en ligne"],
  },
  {
    slug: "roue-des-activites",
    enSlug: "activity-wheel",
    name: "Roue des Activités Scolaires & Ludiques",
    tagline: "Tournez la roue pour désigner le prochain exercice ou atelier.",
    category: "Roues Interactives",
    icon: "Compass",
    keywords: ["roue des activites", "roue exercice ecole", "roue atelier classe"],
  },
  {
    slug: "roue-des-eleves",
    enSlug: "student-wheel",
    name: "Roue des Élèves pour Classe",
    tagline: "Affichez la liste des prénom d'élèves sur une roue animée.",
    category: "Roues Interactives",
    icon: "UserRoundCheck",
    keywords: ["roue des eleves", "roue de classe prenoms", "tourner la roue des eleves"],
  },
  {
    slug: "roue-de-decision",
    enSlug: "decision-wheel",
    name: "Roue de Décision Interactive",
    tagline: "Personnalisez les options pour trancher n'importe quel dilemme.",
    category: "Roues Interactives",
    icon: "Split",
    keywords: ["roue de decision", "roue pour decider", "roue d options personnalisee"],
  },
  {
    slug: "ordre-de-passage-aleatoire",
    enSlug: "random-line-order",
    name: "Ordre de Passage & File d'Attente Aléatoire",
    tagline: "Mélangez la liste pour définir un ordre de passage aux exposés juste.",
    category: "Groupes & Équipes",
    icon: "ListOrdered",
    keywords: ["ordre de passage aleatoire", "ordre d expose au sort", "tirage au sort ordre passage"],
  },
  {
    slug: "tableau-d-affichage-classe",
    enSlug: "classroom-scoreboard",
    name: "Tableau de Scores pour Classe & Équipes",
    tagline: "Comptez les points des équipes en temps réel sur le projecteur.",
    category: "Classe & École",
    icon: "Trophy",
    featured: true,
    keywords: ["tableau d affichage classe", "compteur de points equipe", "tableau de score en ligne"],
  },
  {
    slug: "attribution-des-metiers-de-classe",
    enSlug: "classroom-job-picker",
    name: "Attribution des Métiers & Rôles en Classe",
    tagline: "Distribuez toutes les tâches scolaires de la semaine en un seul tirage.",
    category: "Classe & École",
    icon: "ClipboardList",
    keywords: ["attribution des metiers de classe", "tirage au sort des roles classe", "gestion des metiers ecole"],
  },
  {
    slug: "choix-d-activite-pedagogique",
    enSlug: "activity-picker",
    name: "Sélection d'Activités Pédagogiques",
    tagline: "Trouvez des idées d'échauffement ou de synthèse pour la leçon.",
    category: "Classe & École",
    icon: "Lightbulb",
    keywords: ["selection activite pedagogique", "idees activites classe", "tirage au sort activite cours"],
  },
  {
    slug: "pause-active-generateur",
    enSlug: "brain-break-picker",
    name: "Générateur de Pauses Actives & Pauses Cerveau",
    tagline: "Exercices de mouvement rapides pour remobiliser l'attention des élèves.",
    category: "Classe & École",
    icon: "Wind",
    keywords: ["pause active generateur", "pause cerveau classe", "exercices de pause active ecole"],
  },
  {
    slug: "generateur-de-mime-charades",
    enSlug: "charades-generator",
    name: "Générateur de Mimes & Charades en Français",
    tagline: "Des centaines de mots à mimer (animaux, métiers, objets, actions).",
    category: "Jeux & Animation",
    icon: "Drama",
    featured: true,
    keywords: ["generateur de mime", "jeu du mime mots francais", "charades en ligne gratuit"],
  },
  {
    slug: "generateur-de-mots-pictionary",
    enSlug: "pictionary-word-generator",
    name: "Générateur de Mots à Dessiner Pictionary",
    tagline: "Mots faciles à difficiles pour vos jeux de dessin en groupe.",
    category: "Jeux & Animation",
    icon: "Brush",
    keywords: ["generateur de mots pictionary", "mot a dessiner jeu", "pictionary francais mots"],
  },
  {
    slug: "tu-preferes-generateur",
    enSlug: "would-you-rather-generator",
    name: "Générateur Tu Préfères ? — Débats et Dilemmes",
    tagline: "Questions et dilemmes amusants pour animer un débat d'idées.",
    category: "Jeux & Animation",
    icon: "Scale",
    keywords: ["tu preferes generateur", "jeu tu preferes en ligne", "dilemmes amusants classe"],
  },
  {
    slug: "generateur-de-quiz-culture-generale",
    enSlug: "trivia-question-generator",
    name: "Générateur de Questions de Quiz & Culture Générale",
    tagline: "Sciences, histoire, géographie et culture générale pour vos jeux.",
    category: "Jeux & Animation",
    icon: "Brain",
    keywords: ["generateur de quiz culture generale", "questions de trivia francais", "quiz rapide pour classe"],
  },
  {
    slug: "generateur-de-defis-aleatoires",
    enSlug: "random-challenge-generator",
    name: "Générateur de Défis & Gages Aléatoires",
    tagline: "Défis amusants et bienveillants pour dynamiser vos cours ou événements.",
    category: "Jeux & Animation",
    icon: "Flame",
    keywords: ["generateur de defis aleatoires", "gages amusants ecole", "defis rigolos pour groupes"],
  },
];

export function getFrToolBySlug(slug: string): FrToolMeta | undefined {
  return FR_TOOLS.find((t) => t.slug === slug || t.enSlug === slug);
}

export function getEnSlugForFrSlug(frSlug: string): string {
  const found = FR_TOOLS.find((t) => t.slug === frSlug || t.enSlug === frSlug);
  return found ? found.enSlug : frSlug;
}

export function getFrSlugForEnSlug(enSlug: string): string {
  const found = FR_TOOLS.find((t) => t.enSlug === enSlug || t.slug === enSlug);
  return found ? found.slug : enSlug;
}

export function relatedFrTools(currentSlug: string, count = 4): FrToolMeta[] {
  const current = getFrToolBySlug(currentSlug);
  const sameCategory = FR_TOOLS.filter((t) => t.slug !== current?.slug && t.category === current?.category);
  const others = FR_TOOLS.filter((t) => t.slug !== current?.slug && t.category !== current?.category);
  return [...sameCategory, ...others].slice(0, count);
}
